export default __webpack_public_path__ + "static/media/temp-fan-galleries.d8165ef6.png";